'use strict';

angular.module('shop').component('productOverlay', {
	templateUrl: 'component/product-overlay.html',
	bindings: {
		show: '=',
		product: '<'
	},
	controller: function($rootScope) {
		var self = this;

		this.$onInit = function() {
			self.images = [];
			self.activeIndex = 0;

			if (self.product.imageLarge && self.product.imageLarge !== '' && self.product.imageLarge !== 'http://vaxjo2.sigmatechnology.se/Backend2/Files/Webshop/' && self.product.imageLarge !== 'https://backend.matkomfort.se/Files/Webshop/') {
				self.images.push(self.product.imageLarge);
			}

			if (self.product.imageLarge2 && self.product.imageLarge2 !== '' && self.product.imageLarge2 !== 'http://vaxjo2.sigmatechnology.se/Backend2/Files/Webshop/' && self.product.imageLarge2 !== 'https://backend.matkomfort.se/Files/Webshop/') {
				self.images.push(self.product.imageLarge2);
			}

			if (self.product.imageLarge3 && self.product.imageLarge3 !== '' && self.product.imageLarge3 !== 'http://vaxjo2.sigmatechnology.se/Backend2/Files/Webshop/' && self.product.imageLarge3 !== 'https://backend.matkomfort.se/Files/Webshop/') {
				self.images.push(self.product.imageLarge3);
			}

			if (self.images.length === 0) {
				self.images.push(self.product.imageSmall);
			}

			if (self.product.imageOffer && self.product.imageOffer !== 'http://vaxjo2.sigmatechnology.se/Backend2/Files/Webshop/' && self.product.imageOffer !== 'https://backend.matkomfort.se/Files/Webshop/') {
				self.offerImg = self.product.imageOffer;
			}
		};

		this.prev = function() {
			self.activeIndex = self.activeIndex == 0 ?  self.images.length - 1 : self.activeIndex - 1;
		};

		this.next = function() {
			self.activeIndex = self.activeIndex + 1 < self.images.length ? self.activeIndex + 1 : 0;
		};

		$rootScope.$on('shop-zipcode.check', function() {
			self.show = false;
		});

	}
});